import { envFlags, FLAGS } from '@thoughtspot/env-flags';
import type { RequestPropsType } from './request-interceptor';
import { requestInterceptor } from './request-interceptor';
import { setTokenReceivedAt } from './utils';

const setAuthToken = (value: string) => {
    const valueExists = value !== null && value !== undefined;
    const tokenReceivedAt = Math.floor(Date.now() / 1000);
    if (valueExists) {
        setTokenReceivedAt(tokenReceivedAt);
        requestInterceptor.setHeader('Authorization', `Bearer ${value}`);
    }
};

const setCSRFToken = (value: string) => {
    requestInterceptor.setHeader('X-CSRF-Token', value);
};

(function addOrgsOverrideHeader() {
    requestInterceptor.addHeaderRule('x-thoughtspot-orgsoverride', (url: URL) => {
        const header: Record<string, string> = {};
        // Same-origin only: the header is meaningful only to ThoughtSpot's
        // backend; on cross-origin requests (e.g. Mapbox tiles) it forces a
        // CORS preflight that strict CDNs reject, and leaks the org id.
        // window.origin (matches header-manager.ts) is 'null' only in
        // sandboxed iframes with opaque origins, where the app can't
        // authenticate anyway — dropping the header there is safe.
        if (url.origin !== window.origin) {
            return header;
        }
        const overrideOrgId = envFlags.getValue(FLAGS.overrideOrgId.name);
        if (overrideOrgId != null && overrideOrgId !== -1) {
            header['x-thoughtspot-orgsoverride'] = overrideOrgId;
        }
        return header;
    });
})();



const overrideBrowserFetch = (args: RequestPropsType) => {
    requestInterceptor.overrideFetch(args);
};

const overrideBrowserXhr = (args: RequestPropsType) => {
    requestInterceptor.overrideXHR(args);
};

const overrideBrowserRequest = (args: RequestPropsType) => {
    requestInterceptor.overrideFetch(args);
    requestInterceptor.overrideXHR(args);
};

const overrideRequestOptions = (args: any) => {
    return requestInterceptor.overrideOptions(args);
};

export {
    setAuthToken,
    setCSRFToken,
    overrideBrowserRequest,
    overrideBrowserFetch,
    overrideBrowserXhr,
    overrideRequestOptions,
    RequestPropsType,
};
